"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    height: ", "px;\n    background-image: url('", "');\n    background-size: cover;\n    background-position: center;\n    background-size: ", ";\n    background-repeat: no-repeat;\n"], ["\n    height: ", "px;\n    background-image: url('", "');\n    background-size: cover;\n    background-position: center;\n    background-size: ", ";\n    background-repeat: no-repeat;\n"]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _panel = require("./panel");

var _panel2 = _interopRequireDefault(_panel);

var _theme = require("../theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var panel = function panel(props) {
    return props.theme.panel.types[props.type];
};

var Hero = _panel2.default.extend(_templateObject, function (props) {
    return props.height;
}, function (props) {
    return props.backgroundImage;
}, function (props) {
    return props.backgroundSize;
});

Hero.displayName = "Hero";

Hero.propTypes = {
    height: _propTypes2.default.number,
    backgroundImage: _propTypes2.default.string,
    backgroundSize: _propTypes2.default.string
};

Hero.defaultProps = {
    height: 500,
    backgroundSize: "cover"
};

exports.default = Hero;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/hero.js
// module id = 1010
// module chunks = 95715928098905 168707334958949